module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-900.144c6c86.svg";